import { Pipe, PipeTransform } from '@angular/core';

import { createTileDivider, Tile, TileDivider } from './models';

@Pipe({
    name: 'groupTiles',
    standalone: true,
    pure: true,
})
export class GroupTilesPipe implements PipeTransform {
    transform(tiles: Tile[]): (Tile | TileDivider)[] {
        const allGroupNames = tiles
            .map((tile) => tile.groupName)
            .filter((groupName): groupName is string => !!groupName);

        const uniqueGroupNames = [...new Set(allGroupNames)];

        let groupedTiles: (Tile | TileDivider)[] = [];
        for (const groupName of uniqueGroupNames) {
            groupedTiles = [
                ...groupedTiles,
                createTileDivider(groupName),
                ...tiles.filter((tile) => tile.groupName === groupName),
            ];
        }

        groupedTiles = [...groupedTiles, ...tiles.filter((tile) => !tile.groupName)];

        return groupedTiles;
    }
}
